module.exports = __webpack_public_path__ + "img/img_default.5f3b4637.webp";